import React from 'react';
import BooleanInput from '../Form/BooleanInput';
import FormInput from '../Form/FormInput';
import { Container, Row, Col } from 'reactstrap';
import { useEdit } from '../../Services/EditContext';
import ClientSelector from '../Form/ClientSelector';
import ClientDetailsCard from '../Cards/ClientDetailsCard';
import DepartmentDetailsCard from '../Cards/ClientDepartment';
import { useAuth } from '../../Services/AuthContext';
import DepartmentSelector from '../Form/DepartmentSelector';
import { useFormikContext } from 'formik';

const   ClientStaffDetail = ({ isNewItem,route }) => {
    const [edit] = useEdit();
    const [auth] = useAuth();
    const { values } = useFormikContext();
    const { client, clientDepartment } = values;
    return <React.Fragment>
        <Container>
            <Row>
                <Col>
                    {edit ? <ClientSelector id="clientMasterId" label="Client" /> : <ClientDetailsCard route={route} charterDetails={{ client }} />}
                </Col>
                    <Col>
                    {edit ? <DepartmentSelector route={route} clientIdName='clientMasterId' id="clientDepartmentId" label="Department" /> : <DepartmentDetailsCard route={route} clientDepartment={clientDepartment} />}
                    </Col>
                
            </Row>
            <Row>
                <Col>
                    <Row>
                        <Col>
                            <FormInput id='firstName' label='First Name' />
                        </Col>
                        <Col>
                            <FormInput id='lastName' label='Last Name' />
                        </Col>
                       
                    </Row>
                    <Row>
                        <Col>
                            <FormInput readOnly={!isNewItem} id='email' label='Email' type='email' />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormInput id='phoneNumber' label='Phone Number' type='phone' />
                        </Col>
                    </Row>
                    {auth.role === "Admin" ? <Row>
                        <Col>
                            <BooleanInput id='canViewSupplierInfo' label='Can View Supplier Info?' />
                        </Col>
                    </Row> : null}
                </Col>
            </Row>
        </Container>


    </React.Fragment>
};
export default ClientStaffDetail;

